import _objectSpread from "@babel/runtime-corejs3/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _createSuper from "@babel/runtime-corejs3/helpers/createSuper";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React, { useRef, useContext, createContext, useDebugValue } from "react";
import omit from "lodash/omit";
import { EventEmitter, inBrowser, mergeWithDefined } from "@lilib/utils";
var LoadStore = /*#__PURE__*/function (_EventEmitter) {
  _inherits(LoadStore, _EventEmitter);
  var _super = _createSuper(LoadStore);
  function LoadStore() {
    var _this;
    _classCallCheck(this, LoadStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_loadings", new Map());
    _defineProperty(_assertThisInitialized(_this), "_reloaders", new Map());
    return _this;
  }
  _createClass(LoadStore, [{
    key: "isLoading",
    value: function isLoading(key, loader) {
      if (loader) {
        return this._loadings.get(key) === loader;
      } else {
        return this._loadings.has(key);
      }
    }
  }, {
    key: "setLoading",
    value: function setLoading(key, loader) {
      this._loadings.set(key, loader);
    }
  }, {
    key: "deleteLoading",
    value: function deleteLoading(key, loader) {
      if (loader) {
        if (this._loadings.get(key) === loader) {
          this._loadings["delete"](key);
        }
      } else {
        this._loadings["delete"](key);
      }
    }
  }, {
    key: "getReloaders",
    value: function getReloaders(key) {
      return this._reloaders.get(key) || [];
    }
  }, {
    key: "addReloader",
    value: function addReloader(key, reloader) {
      var reloaders = this._reloaders.get(key);
      if (reloaders) {
        if (!reloaders.includes(reloader)) {
          reloaders.push(reloader);
        }
      } else {
        this._reloaders.set(key, [reloader]);
      }
    }
  }, {
    key: "removeReloader",
    value: function removeReloader(key, reloader) {
      var reloaders = this._reloaders.get(key);
      if (reloaders) {
        var lastIndex = reloaders.lastIndexOf(reloader);
        if (lastIndex >= 0) {
          reloaders.splice(lastIndex, 1);
        }
        if (!reloaders.length) {
          this._reloaders["delete"](key);
        }
      }
    }
  }]);
  return LoadStore;
}(EventEmitter);
var GLOBAL_LOAD_STORE_ID = "__LILIB_HOOKS_GLOBAL_LOAD_STORE__";
var defaultValue = {
  global: false,
  cacheTime: 5 * 60 * 1000,
  staleTime: 0,
  retry: false,
  retryLimit: 3,
  retryInterval: 0,
  fallbackRetry: false,
  fallbackRetryLimit: 3,
  fallbackRetryInterval: 0,
  polling: false,
  pollingInterval: 30 * 1000,
  pollingInPageHiding: false,
  pollingIntervalInPageHiding: 60 * 1000,
  autoReloadWaitTime: 10 * 1000,
  autoReloadOnPageShow: false,
  autoReloadOnWindowFocus: false,
  autoReloadOnNetworkReconnect: false
};
var LoadContext = /*#__PURE__*/createContext(_objectSpread(_objectSpread({}, defaultValue), {}, {
  store: new LoadStore()
}));
export var useLoadConfig = function useLoadConfig() {
  return useContext(LoadContext);
};
var LoadConfig = function LoadConfig(props) {
  var config = useLoadConfig();
  var storeRef = useRef();
  var value = omit(props, "inherit", "children");
  if (props.inherit) {
    value = mergeWithDefined(config, value);
  } else {
    value = mergeWithDefined(defaultValue, value);
  }
  if (value.global && inBrowser && window[GLOBAL_LOAD_STORE_ID]) {
    value.store = window[GLOBAL_LOAD_STORE_ID];
  }
  if (!value.store) {
    if (!storeRef.current) {
      storeRef.current = new LoadStore();
    }
    value.store = storeRef.current;
  }
  if (value.global && inBrowser && !window[GLOBAL_LOAD_STORE_ID]) {
    window[GLOBAL_LOAD_STORE_ID] = value.store;
  }
  useDebugValue(value);
  return /*#__PURE__*/React.createElement(LoadContext.Provider, {
    value: value
  }, props.children);
};
LoadConfig.Context = LoadContext;
LoadConfig.useConfig = useLoadConfig;
export default LoadConfig;